import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.BeheerBox, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isInterneGebruiker && settings.heeftBeheerboxRechten,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.BeheerBox,
    title: 'BeheerBox',
    url: '/app/beheerbox/',
    iconclass: 'far fa-screwdriver-wrench',
    target: '_top',
  }),
});
